var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWcpeLogoWhite01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1360.63 397.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-10,.cls-9{fill:#fff;}.cls-9{stroke:#fff;stroke-miterlimit:10;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 499.19,
    y1: 128.83,
    x2: 716.6,
    y2: 254.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9d9d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 611.46,
    y1: 52.32,
    x2: 702.76,
    y2: 210.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 722.31,
    y1: 51.17,
    x2: 722.31,
    y2: 161.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 795.08,
    y1: 83.95,
    x2: 765.88,
    y2: 134.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 833.32,
    y1: 110.91,
    x2: 800.82,
    y2: 143.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 858.2,
    y1: 138.39,
    x2: 825.18,
    y2: 157.45,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 874.37,
    y1: 161.98,
    x2: 841.45,
    y2: 180.99,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 889,
    y1: 193.21,
    x2: 849.31,
    y2: 193.21,
    xlinkHref: "#linear-gradient-5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M729.64,200.36l-221.34-.12c-34.69.46-39.27-11.43-35.62-22.55,5.13-15.65,19-33.32,29.57-46.39,16.28-20.1,32.56-21.45,60.41-11.57L734,187.11C753.79,196.2,757.27,199.8,729.64,200.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M571.53,102.44c-22.2-10.73-16.38-17.91-7.18-22.91,12.87-7,32-15.67,49.47-20.88,7.43-2.22,15.18-3.42,22.73-1C647.92,61.24,656,69.74,664.11,78l17.11,17.22,43.85,44.11C735.32,149.6,742.77,156.67,753,167c11.12,11.23,8.87,14.37-8,8.08-6-2.24-9.07-3.61-15.07-5.87-17.22-6.52-34.26-13.49-51.27-20.54q-28-11.61-55.82-23.61c-14-6-27.89-12-41.76-18.25C577.91,105.38,574.69,104,571.53,102.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M757.41,147.16,676.56,64.63c-8-8.88-13.54-12.17-4.49-13.14,8.46-.92,27.48.25,40.31,2,18.83,2.6,18.53,3.93,33.46,31.55l21.68,45C788.41,176.4,771,161.39,757.41,147.16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M787.62,137.73,766.39,86.3c-.75-1.77-9.41-22.31.12-17.86,8.64,4,14.12,7.18,20.77,11,9,5.16,10,13.18,10.33,17.07L799,138.07C798.62,152.22,798,160.86,787.62,137.73Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M831.61,120.29l-8,22.35c-8,21.9-10.1,20-10.33-2.47l1.24-35c.34-5.16.08-9.93,6.17-5.61a55.17,55.17,0,0,1,9.66,8.53C834.43,112.43,834.3,112.43,831.61,120.29Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M839.8,162.07c-9.54,8-11,8.78-5.95-3.48,11.79-28.41,14.76-31.25,17.41-28.86,2.87,2.57,5.87,5.32,7.09,10.05C859.22,143.13,844.17,158.42,839.8,162.07Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M871.7,158.14c2,2,3.74,6.05,4.15,6.85,2.47,4.82-1.91,4.94-24.48,16-12.07,6-9.09,1.46-4.49-3.48,4.25-4.56,11-10.78,15.27-14.93C869.9,155.1,870.57,157,871.7,158.14Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M885.06,201l-29.65-.56c-9.32,0-6.62-2.24-.78-4.6l24.14-8.65c7.19-2.47,7.26-3,8.87,2a23.58,23.58,0,0,1,1.35,7.53C889.1,200.1,887.91,200.93,885.06,201Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M117.31,295.3,103.72,345H95.41L77.85,283.38h8.5L100,334.76l14.14-51.38h6.37l14.14,51.38,13.58-51.38h8.51L139.21,345h-8.32Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M225.7,283.38h40.39v6.84H233.37v19.87h32.07v6.84H233.37v21.25h32.72V345H225.7Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M339.46,330.51a26.06,26.06,0,0,0,19.41,8.78c11,0,14.51-5.92,14.51-10.63,0-7.39-7.49-9.42-15.62-11.64-9.89-2.59-20.89-5.36-20.89-17.47,0-10.16,9.06-17.09,21.17-17.09,9.42,0,16.72,3.14,21.9,8.59l-4.62,5.64c-4.62-5.09-11.09-7.4-17.84-7.4-7.39,0-12.66,4-12.66,9.8,0,6.19,7.12,8,15,10.16,10.07,2.69,21.53,5.83,21.53,18.76,0,9-6.1,18.12-22.73,18.12-10.72,0-18.57-4.07-23.66-9.8Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M467.82,290.22h-19.5v-6.84h46.76v6.84H475.49V345h-7.67Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M565.59,283.38H606v6.84H573.26v19.87h32.07v6.84H573.26v21.25H606V345H565.59Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M698.48,320.53h-12.3V345h-7.67V283.38h24.77c11.27,0,19.31,7.21,19.31,18.57,0,11.09-7.57,17.19-16,17.93L723.24,345h-9.06Zm3.88-30.31H686.18v23.56h16.18c7.3,0,12.29-4.89,12.29-11.83S709.66,290.22,702.36,290.22Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M802.71,295.3V345H795V283.38h7.86l35.48,48.7v-48.7h7.67V345h-7.39Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1002.5,314.25c0-18.95,14-31.89,31.42-31.89a27.71,27.71,0,0,1,23.66,12.2l-6.47,3.61a20.9,20.9,0,0,0-17.19-9c-13.21,0-23.47,10.35-23.47,25.05s10.26,25,23.47,25a20.67,20.67,0,0,0,17.19-9l6.56,3.61c-5.17,7-12.56,12.2-23.75,12.2C1016.46,346.13,1002.5,333.19,1002.5,314.25Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1127.81,283.38h24.77c12.38,0,19.31,8.5,19.31,18.57s-7.11,18.58-19.31,18.58h-17.1V345h-7.67Zm23.85,6.84h-16.18v23.47h16.18c7.3,0,12.29-4.8,12.29-11.74S1159,290.22,1151.66,290.22Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1242.4,283.38h40.39v6.84h-32.72v19.87h32.07v6.84h-32.07v21.25h32.72V345H1242.4Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M882.17,286.16h-7.51v-2.63h18v2.63h-7.54v21.1h-3Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M916.87,287.51l-8.08,19.75h-1.21l-8-19.75v19.75h-2.95V283.53h4.23l7.37,18.07,7.4-18.07h4.23v23.73h-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWcpeLogoWhite01);
export default __webpack_public_path__ + "static/media/WCPE_logo_white-01.6b0ffd12c96b0406750fc46a7d783608.svg";
export { ForwardRef as ReactComponent };